import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import uuid from '../Utils/UUID';
import Logo from './Logo';
import NewsLetterSection from './NewsLetter/NewsLetter';
import { translate } from '../../Services/translation';

const Footer = () => {
    const { sectionList, socialMediaLinks, logoUrl, countrySelectorOptions } = useSelector(
    (state) => state.footer
    );
        
    const CountrySelectorUK = () => {
        const [showCountrySelector, setShowCountrySelector] = useState(false);
        const [countrySelectorOptionsState, setCountrySelectorOptionsState] = useState([]);

        useEffect(() => {
            const element = document.getElementById('showCountrySelector');
            if (element) {
                const attributeValue = element.getAttribute('data-show-country-selector');
                const booleanValue = attributeValue.toLowerCase() === 'true';
                setShowCountrySelector(booleanValue);
            }
            setCountrySelectorOptionsState(countrySelectorOptions);
        }, [countrySelectorOptions]);
        
        const icon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFRUlEQVR4nO2a229VVRDGDyUtVqQW1Bde1FJ8UvH2YAQRL9FoNPECqCTaSlCpqBVIuPgkeCE+aPQfqBqfvMbEEi8oKjagUAXUVEHUF8VKDSJeqFr7M9N8K5mz2bfTswutYZIm3Xu+PWt/e62ZNWvmlErHJJ8AJ9pfaawIMA24E3gW+BjYz+GyXzrDLLJnSqNBgMnAUmA7w5dPgQfMVukoEDgJeBw46F7I/h9w1y8As9z1xcCL7nog8vyvwLojQggYBywE+twLvAncAqzW9Z/A7e6ZIXHXLcAh3bZnbgXecvb2Aa021kiRmAK85gbcBMyUbg7wDzAIzI08V0ZE9+YJa89cons2ex86+68WPjvAGcC3bgm1OF0t8KV0D8U8exgR3V8rlT1b6+63Ar9JtwdoLorEucBPMtwdNQwsk+4roK4CInXALqmXRXTTgU+ks7HPKWImAomNwAkRfb3WtMnVCTZiiUh3jfOL+ohuEvC+I9NcTWgNy6kHOD4Gc5f0O1PsJBKRfqcgi2J0E92y/RpoHE508o4dls4Sbwz4SLq2Koi0CbIlkg20uaUX5JWKoplCbHDslcA3ztjfCperHaahCiINzrlXAOuBfjeezcRyt+e0VLLZ9fkvDYy3sCoCRsTL77r/NLAYuAq4AGiy2XO4Rt07X5i7gSeBNxwRv1luUJger3ew1RD8JTssa8c2+QCoSdhPWp2TFyl9ytdOjhm3xu0z6/I4eJjCmRk+dEC4C4FrtSw69CW7FSh+cS95QPcsrL6jxHEVcD1wkcOMSxnX0pyQziTPitsTujIIW5w3+T71y+TwEYfbK2hqRgxsFq49DRSy2BszjNnaNXm9QCKdgs7NOXZ32nnC5A/guAxjlqWarCmQyMOCPpqBq1dianJaHMCczKQzx6AWz03mF0jEMmiTl3JgLdKZLIxTPiflfTkMhdTh0gKJXCboxhzYdmGfiVNulXJODkNfCHtmgUTOFvSzHNgrotmAV4Yz9ukVRJipBRKZKujeHNjgzz/HbTaD2lFrcxj6S4bqCiRiaf2gbKfmUzoD2bv+W7ZpK98ZqzLpf0mkZphLa0IO7JDkwE0QtD8HNn5pjUFnb4p1dimtApg3/H4u7FkFEpmRddp02MuF3RyntGx0rG2IHXFKq8WarM9h6GVhbx6NKco0lzSWVTRisI8Ju/YoJ42nJoGsoGxyU85UurNAInZWrySN35YGssq6ydYMY83C/VAgkR8FbcrAbRHu/qyjrh0jTWblPOraMfUGVVWeVyHPDmjfOUzSUdeOx9fpuBwwaUfd2Q6XXuNyh6ZNCcWHU3R28RX5omSfChtTYsa1Tbsrjx/5WQkVkiWuHDQfeDfSA0GlHIsiT4igpdjn2caaUg66UuWgp1RKspKSFys5vR0pB90rXW/uiqO+CqqoLFeRLEi/ztcrHJFqC3QHlSKtUr8lpECoOLjSVXduy0XC+YD1J6Il08X+pUewZNoI3KMxvWTuMUlLzPoToYg9MaWIvaMKIjsyitg90u8edndYYTa0Fd4rS5lHvq3Q4FKh3qo7wNZkkSG0YU5PKOrtqqLRszSmL7PdkZhRFYnIzOxxzt2a0HpbUwGRkJL0RFpvd7ii9u7Ce/FywFDPQjF9aNO0hqZrhs7LIqJQHpqhs11dt8s79oj9YkLRrMX5DYr3C4AHdX0oMmNlRBTafXt6gQrfQXorCrFVEpqsDCCkM+j/gcgXjf5gIKT/ST8YeKTi9lqBhNrVRhiubJONI08gTqygrJZdhzbKuFysT9lrh7Dx54nRKNoPElOYY1Iql/8A44Gio0Z7vSkAAAAASUVORK5CYII=";

        const langSelectorListRef = useRef(null);

        const hideLangSelectorList = () => {
            const langSelectorList = langSelectorListRef.current;
            if (langSelectorList) {
                langSelectorList.style.display = "none";
            }
        }

        const showLangSelectorList = () => {
            const langSelectorList = langSelectorListRef.current;
            if (langSelectorList) {
                langSelectorList.style.display = "block";
            }
        }

        return (
            showCountrySelector && 
            <div style={{ display: showCountrySelector ? 'block' : 'none' }} className="footer__horizontal-list">
                <div className="top-header-lang-selector footer-lang-selector">
                    <div onMouseEnter={showLangSelectorList} onClick={showLangSelectorList} className="lang-selector-icons">
                        <img src={icon} style={{ maxHeight: '30px' }} alt="icon" />
                        <p>{translate('countryselector.header')}</p>
                        <span>{'>'}</span>
                    </div>
                    <div onMouseLeave={hideLangSelectorList} id="lang-selector-list" ref={langSelectorListRef} style={{ display: 'none' }}>
                        <div className="lang-options">
                            <h4>{translate('countryselector.expand.header')}</h4>
                            <button className="lang-options__close-btn" onClick={hideLangSelectorList}>x</button>
                            {countrySelectorOptionsState && countrySelectorOptionsState.length > 0 &&
                                countrySelectorOptionsState.map((country, index) => (
                                    country.url != null && country.name != null &&
                                    <div key={index} className="lang-option">
                                        <a href={country.url}>
                                            <span className="lang-options__link">{country.name}</span>
                                            <span className="lang-options__icon">{'>'}</span>
                                        </a>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div> 
        );
    };

  const mapLinkItems = ({ href, text }) => (
    <p key={uuid()}>
      <a className="footer__link" href={href}>
        {text}
      </a>
    </p>
  );

  const getSectionText = ({ value }) => (
    <div className='footer__section__text'
      dangerouslySetInnerHTML={{
        __html: value,
      }}
    ></div>
  );

    const mapSectionList = (i, k) =>
        k < 3 ? renderColumn(i, k) : renderFullWidth(i);

  const renderColumn = (
    { sectionTitle, sectionSubTitle, sectionLinkList, sectionText },
    index
  ) => (
    <section
      key={uuid()}
      className="columns small-10 small-offset-1 medium-offset-0 medium-3 footer__section"
    >
      <h4 className="footer__title">{sectionTitle}</h4>
      <h5 className="footer__subtitle">{sectionSubTitle}</h5>
      {getSectionText(sectionText)}
      <div>{sectionLinkList?.map(mapLinkItems)}</div>
      {index === 1 && (
        <div className="social-media-links">
          {socialMediaLinks?.map(mapSocialMediaLinks)}
        </div>
      )}
    </section>
    );

  const renderFullWidth = ({ sectionTitle, sectionLinkList }) => (
      <section key={uuid()} className="columns small-10 small-offset-1 medium-offset-0 medium-12 footer__section">
           
          <div className="footer__horizontal-list footer__horizontal-list-with-langselector">
              <Logo src={logoUrl} />
              {showCountrySelector && <>{CountrySelectorUK()}</>} 
          </div>               
          <div className="footer__horizontal-list">   
              {sectionTitle != null && 
              <h4 className="footer__horizontal-list__title">{sectionTitle}</h4>
              }
              {sectionLinkList?.map(({ href, text }) => (
                  href =! null && text != null &&
                      <a className="footer__horizontal-list__link" href={href} key={uuid()}>
                          {text}
                      </a>
                         
                ))}
          <div id="renderPrivateOrBusinessFooterSelector"></div>
      </div>
    </section>
  );

  const mapSocialMediaLinks = ({ url, imageUrl }) => {
    return (
      <a key={uuid()} href={url} target="_blank">
        <img src={imageUrl} />
      </a>
    );
  };

  return (
    <footer className="footer">
      <NewsLetterSection />
      <div className="row">
        {sectionList?.map(mapSectionList)}
          </div>
    </footer>
  );
};

export default Footer;
